import Vue from "vue";
import OrderDirection from "@share/chat/enums/OrderDirection";

export class MessagesFetcher {
    loading = false;
    pageLoading = false;

    //@todo make type for config
    constructor(
        private readonly component: Vue,
        private readonly config: any
    ) {}

    async fetchMessages() {
        this.loading = true;
        try {
            await this.component.$store.dispatch('chat/room/fetchMessages', {initials: true});
            return true;
        }
        catch (e) {
            await this.component.$store.dispatch('reportException', e, {root: true});
            return false;
        }
        finally {
            this.loading = false;
        }
    }

    async fetchPage() {
        const params = this.getParams();

        this.pageLoading = true;

        try {
            await this.component.$store.dispatch('chat/room/fetchMessages', params);
            return params.lastMessageID;
        }
        catch (e) {
            await this.component.$store.dispatch('reportException', e, {root: true});
            return  null;
        }
        finally {
            this.pageLoading = false;
        }
    }

    getLastId() {
        return this.component.$store.state.chat.room.messages.length
            ? this.component.$store.state.chat.room.messages[0].id
            : null;
    }

    getParams() {
        const take = this.config.messagesPerPage;
        return {
            take: take,
            lastMessageID: this.getLastId(),
            direction: OrderDirection.older
        }
    }
}
